import Te, { createContext as g0, useReducer as x0, useState as Ue, useEffect as q, useContext as O, Suspense as w0 } from "react";
var Se = { exports: {} }, ee = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var He;
function y0() {
  if (He) return ee;
  He = 1;
  var a = Te, l = Symbol.for("react.element"), p = Symbol.for("react.fragment"), x = Object.prototype.hasOwnProperty, y = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function v(g, f, N) {
    var b, R = {}, F = null, L = null;
    N !== void 0 && (F = "" + N), f.key !== void 0 && (F = "" + f.key), f.ref !== void 0 && (L = f.ref);
    for (b in f) x.call(f, b) && !s.hasOwnProperty(b) && (R[b] = f[b]);
    if (g && g.defaultProps) for (b in f = g.defaultProps, f) R[b] === void 0 && (R[b] = f[b]);
    return { $$typeof: l, type: g, key: F, ref: L, props: R, _owner: y.current };
  }
  return ee.Fragment = p, ee.jsx = v, ee.jsxs = v, ee;
}
var te = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var We;
function b0() {
  return We || (We = 1, process.env.NODE_ENV !== "production" && function() {
    var a = Te, l = Symbol.for("react.element"), p = Symbol.for("react.portal"), x = Symbol.for("react.fragment"), y = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), v = Symbol.for("react.provider"), g = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), N = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), R = Symbol.for("react.memo"), F = Symbol.for("react.lazy"), L = Symbol.for("react.offscreen"), J = Symbol.iterator, re = "@@iterator";
    function ae(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = J && e[J] || e[re];
      return typeof r == "function" ? r : null;
    }
    var S = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(e) {
      {
        for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
          n[i - 1] = arguments[i];
        ne("error", e, n);
      }
    }
    function ne(e, r, n) {
      {
        var i = S.ReactDebugCurrentFrame, d = i.getStackAddendum();
        d !== "" && (r += "%s", n = n.concat([d]));
        var h = n.map(function(u) {
          return String(u);
        });
        h.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, h);
      }
    }
    var z = !1, ie = !1, le = !1, oe = !1, D = !1, se;
    se = Symbol.for("react.module.reference");
    function xe(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === x || e === s || D || e === y || e === N || e === b || oe || e === L || z || ie || le || typeof e == "object" && e !== null && (e.$$typeof === F || e.$$typeof === R || e.$$typeof === v || e.$$typeof === g || e.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === se || e.getModuleId !== void 0));
    }
    function I(e, r, n) {
      var i = e.displayName;
      if (i)
        return i;
      var d = r.displayName || r.name || "";
      return d !== "" ? n + "(" + d + ")" : n;
    }
    function W(e) {
      return e.displayName || "Context";
    }
    function _(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case x:
          return "Fragment";
        case p:
          return "Portal";
        case s:
          return "Profiler";
        case y:
          return "StrictMode";
        case N:
          return "Suspense";
        case b:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case g:
            var r = e;
            return W(r) + ".Consumer";
          case v:
            var n = e;
            return W(n._context) + ".Provider";
          case f:
            return I(e, e.render, "ForwardRef");
          case R:
            var i = e.displayName || null;
            return i !== null ? i : _(e.type) || "Memo";
          case F: {
            var d = e, h = d._payload, u = d._init;
            try {
              return _(u(h));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var P = Object.assign, M = 0, ce, ue, fe, de, he, ve, me;
    function c() {
    }
    c.__reactDisabledLog = !0;
    function m() {
      {
        if (M === 0) {
          ce = console.log, ue = console.info, fe = console.warn, de = console.error, he = console.group, ve = console.groupCollapsed, me = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: c,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        M++;
      }
    }
    function U() {
      {
        if (M--, M === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: P({}, e, {
              value: ce
            }),
            info: P({}, e, {
              value: ue
            }),
            warn: P({}, e, {
              value: fe
            }),
            error: P({}, e, {
              value: de
            }),
            group: P({}, e, {
              value: he
            }),
            groupCollapsed: P({}, e, {
              value: ve
            }),
            groupEnd: P({}, e, {
              value: me
            })
          });
        }
        M < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var V = S.ReactCurrentDispatcher, Z;
    function $(e, r, n) {
      {
        if (Z === void 0)
          try {
            throw Error();
          } catch (d) {
            var i = d.stack.trim().match(/\n( *(at )?)/);
            Z = i && i[1] || "";
          }
        return `
` + Z + e;
      }
    }
    var K = !1, B;
    {
      var Be = typeof WeakMap == "function" ? WeakMap : Map;
      B = new Be();
    }
    function ke(e, r) {
      if (!e || K)
        return "";
      {
        var n = B.get(e);
        if (n !== void 0)
          return n;
      }
      var i;
      K = !0;
      var d = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var h;
      h = V.current, V.current = null, m();
      try {
        if (r) {
          var u = function() {
            throw Error();
          };
          if (Object.defineProperty(u.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(u, []);
            } catch (C) {
              i = C;
            }
            Reflect.construct(e, [], u);
          } else {
            try {
              u.call();
            } catch (C) {
              i = C;
            }
            e.call(u.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (C) {
            i = C;
          }
          e();
        }
      } catch (C) {
        if (C && i && typeof C.stack == "string") {
          for (var o = C.stack.split(`
`), T = i.stack.split(`
`), w = o.length - 1, j = T.length - 1; w >= 1 && j >= 0 && o[w] !== T[j]; )
            j--;
          for (; w >= 1 && j >= 0; w--, j--)
            if (o[w] !== T[j]) {
              if (w !== 1 || j !== 1)
                do
                  if (w--, j--, j < 0 || o[w] !== T[j]) {
                    var A = `
` + o[w].replace(" at new ", " at ");
                    return e.displayName && A.includes("<anonymous>") && (A = A.replace("<anonymous>", e.displayName)), typeof e == "function" && B.set(e, A), A;
                  }
                while (w >= 1 && j >= 0);
              break;
            }
        }
      } finally {
        K = !1, V.current = h, U(), Error.prepareStackTrace = d;
      }
      var G = e ? e.displayName || e.name : "", H = G ? $(G) : "";
      return typeof e == "function" && B.set(e, H), H;
    }
    function Ye(e, r, n) {
      return ke(e, !1);
    }
    function Ge(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function pe(e, r, n) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return ke(e, Ge(e));
      if (typeof e == "string")
        return $(e);
      switch (e) {
        case N:
          return $("Suspense");
        case b:
          return $("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case f:
            return Ye(e.render);
          case R:
            return pe(e.type, r, n);
          case F: {
            var i = e, d = i._payload, h = i._init;
            try {
              return pe(h(d), r, n);
            } catch {
            }
          }
        }
      return "";
    }
    var X = Object.prototype.hasOwnProperty, Ce = {}, Oe = S.ReactDebugCurrentFrame;
    function ge(e) {
      if (e) {
        var r = e._owner, n = pe(e.type, e._source, r ? r.type : null);
        Oe.setExtraStackFrame(n);
      } else
        Oe.setExtraStackFrame(null);
    }
    function qe(e, r, n, i, d) {
      {
        var h = Function.call.bind(X);
        for (var u in e)
          if (h(e, u)) {
            var o = void 0;
            try {
              if (typeof e[u] != "function") {
                var T = Error((i || "React class") + ": " + n + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw T.name = "Invariant Violation", T;
              }
              o = e[u](r, u, i, n, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (w) {
              o = w;
            }
            o && !(o instanceof Error) && (ge(d), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", i || "React class", n, u, typeof o), ge(null)), o instanceof Error && !(o.message in Ce) && (Ce[o.message] = !0, ge(d), E("Failed %s type: %s", n, o.message), ge(null));
          }
      }
    }
    var Je = Array.isArray;
    function we(e) {
      return Je(e);
    }
    function Ke(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, n = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return n;
      }
    }
    function Xe(e) {
      try {
        return Ae(e), !1;
      } catch {
        return !0;
      }
    }
    function Ae(e) {
      return "" + e;
    }
    function Ne(e) {
      if (Xe(e))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ke(e)), Ae(e);
    }
    var Q = S.ReactCurrentOwner, Qe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Fe, De, ye;
    ye = {};
    function e0(e) {
      if (X.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function t0(e) {
      if (X.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function r0(e, r) {
      if (typeof e.ref == "string" && Q.current && r && Q.current.stateNode !== r) {
        var n = _(Q.current.type);
        ye[n] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', _(Q.current.type), e.ref), ye[n] = !0);
      }
    }
    function a0(e, r) {
      {
        var n = function() {
          Fe || (Fe = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        n.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: n,
          configurable: !0
        });
      }
    }
    function n0(e, r) {
      {
        var n = function() {
          De || (De = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        n.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: n,
          configurable: !0
        });
      }
    }
    var i0 = function(e, r, n, i, d, h, u) {
      var o = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: l,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: n,
        props: u,
        // Record the component responsible for creating this element.
        _owner: h
      };
      return o._store = {}, Object.defineProperty(o._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(o, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: i
      }), Object.defineProperty(o, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: d
      }), Object.freeze && (Object.freeze(o.props), Object.freeze(o)), o;
    };
    function l0(e, r, n, i, d) {
      {
        var h, u = {}, o = null, T = null;
        n !== void 0 && (Ne(n), o = "" + n), t0(r) && (Ne(r.key), o = "" + r.key), e0(r) && (T = r.ref, r0(r, d));
        for (h in r)
          X.call(r, h) && !Qe.hasOwnProperty(h) && (u[h] = r[h]);
        if (e && e.defaultProps) {
          var w = e.defaultProps;
          for (h in w)
            u[h] === void 0 && (u[h] = w[h]);
        }
        if (o || T) {
          var j = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          o && a0(u, j), T && n0(u, j);
        }
        return i0(e, o, T, d, i, Q.current, u);
      }
    }
    var be = S.ReactCurrentOwner, Pe = S.ReactDebugCurrentFrame;
    function Y(e) {
      if (e) {
        var r = e._owner, n = pe(e.type, e._source, r ? r.type : null);
        Pe.setExtraStackFrame(n);
      } else
        Pe.setExtraStackFrame(null);
    }
    var Ee;
    Ee = !1;
    function je(e) {
      return typeof e == "object" && e !== null && e.$$typeof === l;
    }
    function Le() {
      {
        if (be.current) {
          var e = _(be.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function o0(e) {
      return "";
    }
    var ze = {};
    function s0(e) {
      {
        var r = Le();
        if (!r) {
          var n = typeof e == "string" ? e : e.displayName || e.name;
          n && (r = `

Check the top-level render call using <` + n + ">.");
        }
        return r;
      }
    }
    function Ie(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var n = s0(r);
        if (ze[n])
          return;
        ze[n] = !0;
        var i = "";
        e && e._owner && e._owner !== be.current && (i = " It was passed a child from " + _(e._owner.type) + "."), Y(e), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', n, i), Y(null);
      }
    }
    function Me(e, r) {
      {
        if (typeof e != "object")
          return;
        if (we(e))
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            je(i) && Ie(i, r);
          }
        else if (je(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var d = ae(e);
          if (typeof d == "function" && d !== e.entries)
            for (var h = d.call(e), u; !(u = h.next()).done; )
              je(u.value) && Ie(u.value, r);
        }
      }
    }
    function c0(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var n;
        if (typeof r == "function")
          n = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === R))
          n = r.propTypes;
        else
          return;
        if (n) {
          var i = _(r);
          qe(n, e.props, "prop", i, e);
        } else if (r.PropTypes !== void 0 && !Ee) {
          Ee = !0;
          var d = _(r);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", d || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function u0(e) {
      {
        for (var r = Object.keys(e.props), n = 0; n < r.length; n++) {
          var i = r[n];
          if (i !== "children" && i !== "key") {
            Y(e), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", i), Y(null);
            break;
          }
        }
        e.ref !== null && (Y(e), E("Invalid attribute `ref` supplied to `React.Fragment`."), Y(null));
      }
    }
    var Ve = {};
    function $e(e, r, n, i, d, h) {
      {
        var u = xe(e);
        if (!u) {
          var o = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (o += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var T = o0();
          T ? o += T : o += Le();
          var w;
          e === null ? w = "null" : we(e) ? w = "array" : e !== void 0 && e.$$typeof === l ? (w = "<" + (_(e.type) || "Unknown") + " />", o = " Did you accidentally export a JSX literal instead of a component?") : w = typeof e, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", w, o);
        }
        var j = l0(e, r, n, d, h);
        if (j == null)
          return j;
        if (u) {
          var A = r.children;
          if (A !== void 0)
            if (i)
              if (we(A)) {
                for (var G = 0; G < A.length; G++)
                  Me(A[G], e);
                Object.freeze && Object.freeze(A);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Me(A, e);
        }
        if (X.call(r, "key")) {
          var H = _(e), C = Object.keys(r).filter(function(p0) {
            return p0 !== "key";
          }), _e = C.length > 0 ? "{key: someKey, " + C.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ve[H + _e]) {
            var m0 = C.length > 0 ? "{" + C.join(": ..., ") + ": ...}" : "{}";
            E(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, _e, H, m0, H), Ve[H + _e] = !0;
          }
        }
        return e === x ? u0(j) : c0(j), j;
      }
    }
    function f0(e, r, n) {
      return $e(e, r, n, !0);
    }
    function d0(e, r, n) {
      return $e(e, r, n, !1);
    }
    var h0 = d0, v0 = f0;
    te.Fragment = x, te.jsx = h0, te.jsxs = v0;
  }()), te;
}
process.env.NODE_ENV === "production" ? Se.exports = y0() : Se.exports = b0();
var t = Se.exports;
const E0 = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/tiff"
], j0 = (a, l) => {
  const p = a.fileData.length - 1, x = (s) => {
    const v = a.fileData[s];
    return {
      zoom: !0,
      fileSrc: URL.createObjectURL(v),
      index: s,
      isImage: E0.includes(v.type),
      fileName: v.name,
      type: v.type,
      size: v.size
    };
  }, y = (s) => {
    s && s.fileSrc && s.fileSrc.startsWith("blob:") && URL.revokeObjectURL(s.fileSrc);
  };
  switch (l.type) {
    case "STORE_FILE_DATA":
      return { ...a, fileData: l.payload.files };
    case "SET_COMPONENT_STATE":
      return { ...a, componentState: l.payload };
    case "APPEND_FILE_DATA":
      return { ...a, fileData: [...a.fileData, ...l.payload.files] };
    case "STORE_FILE_STATE":
      return { ...a, fileState: l.payload };
    case "SET_IMAGE_EDITOR_DATA":
      return { ...a, imageEditorState: l.payload };
    case "REMOVE_FILE_DATA":
      return {
        ...a,
        fileData: a.fileData.filter((s) => s.name !== l.payload.name)
      };
    case "GET_NEXT_FILE": {
      const s = a.fileState.index + 1, v = s > p ? 0 : s;
      return y(a.fileState), {
        ...a,
        fileState: x(v)
      };
    }
    case "GET_PREV_FILE": {
      const s = a.fileState.index - 1, v = s < 0 ? p : s;
      return y(a.fileState), {
        ...a,
        fileState: x(v)
      };
    }
    default:
      return a;
  }
}, k = g0({
  state: {
    fileData: [],
    fileState: {
      zoom: !1,
      fileSrc: null,
      index: 0,
      isImage: !1,
      fileName: null,
      type: null,
      size: 0
    },
    componentState: {
      showFileSize: !0,
      showSliderCount: !0,
      downloadFile: !0,
      removeFile: !0,
      rounded: !0,
      fileHeight: "h-32",
      fileWidth: "w-44",
      disabled: !1,
      allowEditing: !1
    },
    imageEditorState: {
      isEditing: !1,
      index: null,
      file: null
    }
  },
  dispatch: () => {
  }
}), _0 = ({ children: a }) => {
  const [l, p] = x0(j0, {
    fileData: [],
    fileState: {
      zoom: !1,
      fileSrc: null,
      index: 0,
      isImage: !1,
      fileName: null,
      type: null,
      size: 0
    },
    componentState: {
      showFileSize: !0,
      showSliderCount: !0,
      downloadFile: !0,
      removeFile: !0,
      rounded: !0,
      fileHeight: "h-32",
      fileWidth: "w-44"
    },
    imageEditorState: {
      isEditing: !1,
      index: null,
      file: null
    }
  });
  return /* @__PURE__ */ t.jsx(k.Provider, { value: { state: l, dispatch: p }, children: a });
}, R0 = ({ file: a, fileSrc: l, index: p, isImage: x }) => {
  const [y, s] = Ue(null);
  q(() => {
    a.size < 1e6 ? s(Math.floor(a.size / 1e3) + " KB") : s(Math.floor(a.size / 1e6) + " MB");
  }, [a]);
  const v = a.name.split(".");
  let g = v[0];
  const f = v.pop();
  g.length > 20 && (g = g.substring(0, 5) + ".." + g.substring(g.length - 3, g.length));
  const N = g + "." + f, b = O(k).state.componentState, { dispatch: R } = O(k), F = () => {
    R({
      type: "SET_IMAGE_EDITOR_DATA",
      payload: {
        isEditing: !0,
        file: a,
        index: p
      }
    });
  };
  return /* @__PURE__ */ t.jsxs("div", { className: "relative ", children: [
    /* @__PURE__ */ t.jsx("h5", { className: "text-[12px] mt-1 font-normal break-words text-black dark:text-slate-100", children: N }),
    b.showFileSize && /* @__PURE__ */ t.jsx("span", { "data-testid": "file-size", className: "text-[10px] text-black dark:text-slate-100", children: y }),
    b.downloadFile && l && /* @__PURE__ */ t.jsx(
      "a",
      {
        className: "float-right absolute top-1 right-0 text-gray-500 dark:text-white",
        href: l,
        target: "_blank",
        download: a == null ? void 0 : a.name,
        rel: "noreferrer",
        children: /* @__PURE__ */ t.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-4 w-4", fill: "currentColor", viewBox: "0 0 16 16", children: [
          /* @__PURE__ */ t.jsx("path", { d: "M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" }),
          /* @__PURE__ */ t.jsx("path", { d: "M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" })
        ] })
      }
    ),
    b.allowEditing && x && /* @__PURE__ */ t.jsx(
      "button",
      {
        className: "float-right absolute top-1 right-5 text-gray-500 dark:text-white",
        onClick: F,
        children: /* @__PURE__ */ t.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "currentColor", className: "h-4 w-4", viewBox: "0 0 16 16", children: [
          /* @__PURE__ */ t.jsx("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }),
          /* @__PURE__ */ t.jsx("path", { fillRule: "evenodd", d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" })
        ] })
      }
    )
  ] });
}, Ze = [
  {
    type: "application/pdf",
    icon: /* @__PURE__ */ t.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-10 fill-white", fill: "currentColor", viewBox: "0 0 16 16", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M5.523 10.424c.14-.082.293-.162.459-.238a7.878 7.878 0 0 1-.45.606c-.28.337-.498.516-.635.572a.266.266 0 0 1-.035.012.282.282 0 0 1-.026-.044c-.056-.11-.054-.216.04-.36.106-.165.319-.354.647-.548zm2.455-1.647c-.119.025-.237.05-.356.078a21.035 21.035 0 0 0 .5-1.05 11.96 11.96 0 0 0 .51.858c-.217.032-.436.07-.654.114zm2.525.939a3.888 3.888 0 0 1-.435-.41c.228.005.434.022.612.054.317.057.466.147.518.209a.095.095 0 0 1 .026.064.436.436 0 0 1-.06.2.307.307 0 0 1-.094.124.107.107 0 0 1-.069.015c-.09-.003-.258-.066-.498-.256zM8.278 4.97c-.04.244-.108.524-.2.829a4.86 4.86 0 0 1-.089-.346c-.076-.353-.087-.63-.046-.822.038-.177.11-.248.196-.283a.517.517 0 0 1 .145-.04c.013.03.028.092.032.198.005.122-.007.277-.038.465z" }),
      /* @__PURE__ */ t.jsx("path", { fillRule: "evenodd", d: "M4 0h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm.165 11.668c.09.18.23.343.438.419.207.075.412.04.58-.03.318-.13.635-.436.926-.786.333-.401.683-.927 1.021-1.51a11.64 11.64 0 0 1 1.997-.406c.3.383.61.713.91.95.28.22.603.403.934.417a.856.856 0 0 0 .51-.138c.155-.101.27-.247.354-.416.09-.181.145-.37.138-.563a.844.844 0 0 0-.2-.518c-.226-.27-.596-.4-.96-.465a5.76 5.76 0 0 0-1.335-.05 10.954 10.954 0 0 1-.98-1.686c.25-.66.437-1.284.52-1.794.036-.218.055-.426.048-.614a1.238 1.238 0 0 0-.127-.538.7.7 0 0 0-.477-.365c-.202-.043-.41 0-.601.077-.377.15-.576.47-.651.823-.073.34-.04.736.046 1.136.088.406.238.848.43 1.295a19.707 19.707 0 0 1-1.062 2.227 7.662 7.662 0 0 0-1.482.645c-.37.22-.699.48-.897.787-.21.326-.275.714-.08 1.103z" })
    ] }),
    color: "bg-red-500"
  },
  {
    type: "text/csv",
    icon: /* @__PURE__ */ t.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-10 fill-white", fill: "currentColor", viewBox: "0 0 16 16", children: /* @__PURE__ */ t.jsx("path", { fillRule: "evenodd", d: "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM3.397 14.841a1.13 1.13 0 0 0 .401.823c.13.108.289.192.478.252.19.061.411.091.665.091.338 0 .624-.053.859-.158.236-.105.416-.252.539-.44.125-.189.187-.408.187-.656 0-.224-.045-.41-.134-.56a1.001 1.001 0 0 0-.375-.357 2.027 2.027 0 0 0-.566-.21l-.621-.144a.97.97 0 0 1-.404-.176.37.37 0 0 1-.144-.299c0-.156.062-.284.185-.384.125-.101.296-.152.512-.152.143 0 .266.023.37.068a.624.624 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.092 1.092 0 0 0-.2-.566 1.21 1.21 0 0 0-.5-.41 1.813 1.813 0 0 0-.78-.152c-.293 0-.551.05-.776.15-.225.099-.4.24-.527.421-.127.182-.19.395-.19.639 0 .201.04.376.122.524.082.149.2.27.352.367.152.095.332.167.539.213l.618.144c.207.049.361.113.463.193a.387.387 0 0 1 .152.326.505.505 0 0 1-.085.29.559.559 0 0 1-.255.193c-.111.047-.249.07-.413.07-.117 0-.223-.013-.32-.04a.838.838 0 0 1-.248-.115.578.578 0 0 1-.255-.384h-.765ZM.806 13.693c0-.248.034-.46.102-.633a.868.868 0 0 1 .302-.399.814.814 0 0 1 .475-.137c.15 0 .283.032.398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.441 1.441 0 0 0-.489-.272 1.838 1.838 0 0 0-.606-.097c-.356 0-.66.074-.911.223-.25.148-.44.359-.572.632-.13.274-.196.6-.196.979v.498c0 .379.064.704.193.976.131.271.322.48.572.626.25.145.554.217.914.217.293 0 .554-.055.785-.164.23-.11.414-.26.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.799.799 0 0 1-.118.363.7.7 0 0 1-.272.25.874.874 0 0 1-.401.087.845.845 0 0 1-.478-.132.833.833 0 0 1-.299-.392 1.699 1.699 0 0 1-.102-.627v-.495ZM6.78 15.29a1.176 1.176 0 0 1-.111-.449h.764a.578.578 0 0 0 .255.384c.07.049.154.087.25.114.095.028.201.041.319.041.164 0 .301-.023.413-.07a.559.559 0 0 0 .255-.193.507.507 0 0 0 .085-.29.387.387 0 0 0-.153-.326c-.101-.08-.256-.144-.463-.193l-.618-.143a1.72 1.72 0 0 1-.539-.214 1 1 0 0 1-.351-.367 1.068 1.068 0 0 1-.123-.524c0-.244.063-.457.19-.639.127-.181.303-.322.527-.422.225-.1.484-.149.777-.149.304 0 .564.05.779.152.217.102.384.239.5.41.12.17.187.359.2.566h-.75a.56.56 0 0 0-.12-.258.624.624 0 0 0-.246-.181.923.923 0 0 0-.37-.068c-.216 0-.387.05-.512.152a.472.472 0 0 0-.184.384c0 .121.047.22.143.3a.97.97 0 0 0 .404.175l.621.143c.217.05.406.12.566.211.16.09.285.21.375.358.09.148.135.335.135.56 0 .247-.063.466-.188.656a1.216 1.216 0 0 1-.539.439c-.234.105-.52.158-.858.158-.254 0-.476-.03-.665-.09a1.404 1.404 0 0 1-.478-.252 1.13 1.13 0 0 1-.29-.375Z" }) }),
    color: "bg-emerald-600"
  },
  {
    type: "text/plain",
    icon: /* @__PURE__ */ t.jsxs("svg", { "data-testid": "preview-icon", xmlns: "http://www.w3.org/2000/svg", className: "h-10 fill-white text-4xl", fill: "currentColor", viewBox: "0 0 16 16", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z" }),
      /* @__PURE__ */ t.jsx("path", { d: "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" })
    ] }),
    color: "bg-slate-500"
  },
  {
    type: "application/msword",
    icon: /* @__PURE__ */ t.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-10 fill-white", fill: "currentColor", viewBox: "0 0 16 16", children: /* @__PURE__ */ t.jsx("path", { fillRule: "evenodd", d: "M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5Zm-7.839 9.166v.522c0 .256-.039.47-.117.641a.861.861 0 0 1-.322.387.877.877 0 0 1-.469.126.883.883 0 0 1-.471-.126.868.868 0 0 1-.32-.386 1.55 1.55 0 0 1-.117-.642v-.522c0-.257.04-.471.117-.641a.868.868 0 0 1 .32-.387.868.868 0 0 1 .471-.129c.176 0 .332.043.469.13a.861.861 0 0 1 .322.386c.078.17.117.384.117.641Zm.803.519v-.513c0-.377-.068-.7-.205-.972a1.46 1.46 0 0 0-.589-.63c-.254-.147-.56-.22-.917-.22-.355 0-.662.073-.92.22a1.441 1.441 0 0 0-.589.627c-.136.271-.205.596-.205.975v.513c0 .375.069.7.205.973.137.271.333.48.59.627.257.144.564.216.92.216.357 0 .662-.072.916-.216.256-.147.452-.356.59-.627.136-.274.204-.598.204-.973ZM0 11.926v4h1.459c.402 0 .735-.08.999-.238a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.59-.68c-.263-.156-.598-.234-1.004-.234H0Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.141 1.141 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082H.79V12.57Zm7.422.483a1.732 1.732 0 0 0-.103.633v.495c0 .246.034.455.103.627a.834.834 0 0 0 .298.393.845.845 0 0 0 .478.131.868.868 0 0 0 .401-.088.699.699 0 0 0 .273-.248.8.8 0 0 0 .117-.364h.765v.076a1.268 1.268 0 0 1-.226.674c-.137.194-.32.345-.55.454a1.81 1.81 0 0 1-.786.164c-.36 0-.664-.072-.914-.216a1.424 1.424 0 0 1-.571-.627c-.13-.272-.194-.597-.194-.976v-.498c0-.379.066-.705.197-.978.13-.274.321-.485.571-.633.252-.149.556-.223.911-.223.219 0 .421.032.607.097.187.062.35.153.489.272a1.326 1.326 0 0 1 .466.964v.073H9.78a.85.85 0 0 0-.12-.38.7.7 0 0 0-.273-.261.802.802 0 0 0-.398-.097.814.814 0 0 0-.475.138.868.868 0 0 0-.301.398Z" }) }),
    color: "bg-sky-600"
  },
  {
    type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    icon: /* @__PURE__ */ t.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-10 fill-white", fill: "currentColor", viewBox: "0 0 16 16", children: /* @__PURE__ */ t.jsx("path", { fillRule: "evenodd", d: "M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5Zm-6.839 9.688v-.522a1.54 1.54 0 0 0-.117-.641.861.861 0 0 0-.322-.387.862.862 0 0 0-.469-.129.868.868 0 0 0-.471.13.868.868 0 0 0-.32.386 1.54 1.54 0 0 0-.117.641v.522c0 .256.04.47.117.641a.868.868 0 0 0 .32.387.883.883 0 0 0 .471.126.877.877 0 0 0 .469-.126.861.861 0 0 0 .322-.386 1.55 1.55 0 0 0 .117-.642Zm.803-.516v.513c0 .375-.068.7-.205.973a1.47 1.47 0 0 1-.589.627c-.254.144-.56.216-.917.216a1.86 1.86 0 0 1-.92-.216 1.463 1.463 0 0 1-.589-.627 2.151 2.151 0 0 1-.205-.973v-.513c0-.379.069-.704.205-.975.137-.274.333-.483.59-.627.257-.147.564-.22.92-.22.357 0 .662.073.916.22.256.146.452.356.59.63.136.271.204.595.204.972ZM1 15.925v-3.999h1.459c.406 0 .741.078 1.005.235.264.156.46.382.589.68.13.296.196.655.196 1.074 0 .422-.065.784-.196 1.084-.131.301-.33.53-.595.689-.264.158-.597.237-.999.237H1Zm1.354-3.354H1.79v2.707h.563c.185 0 .346-.028.483-.082a.8.8 0 0 0 .334-.252c.088-.114.153-.254.196-.422a2.3 2.3 0 0 0 .068-.592c0-.3-.04-.552-.118-.753a.89.89 0 0 0-.354-.454c-.158-.102-.361-.152-.61-.152Zm6.756 1.116c0-.248.034-.46.103-.633a.868.868 0 0 1 .301-.398.814.814 0 0 1 .475-.138c.15 0 .283.032.398.097a.7.7 0 0 1 .273.26.85.85 0 0 1 .12.381h.765v-.073a1.33 1.33 0 0 0-.466-.964 1.44 1.44 0 0 0-.49-.272 1.836 1.836 0 0 0-.606-.097c-.355 0-.66.074-.911.223-.25.148-.44.359-.571.633-.131.273-.197.6-.197.978v.498c0 .379.065.704.194.976.13.271.321.48.571.627.25.144.555.216.914.216.293 0 .555-.054.785-.164.23-.11.414-.26.551-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.765a.8.8 0 0 1-.117.364.699.699 0 0 1-.273.248.874.874 0 0 1-.401.088.845.845 0 0 1-.478-.131.834.834 0 0 1-.298-.393 1.7 1.7 0 0 1-.103-.627v-.495Zm5.092-1.76h.894l-1.275 2.006 1.254 1.992h-.908l-.85-1.415h-.035l-.852 1.415h-.862l1.24-2.015-1.228-1.984h.932l.832 1.439h.035l.823-1.439Z" }) }),
    color: "bg-sky-600"
  },
  {
    type: "application/vnd.ms-excel",
    icon: /* @__PURE__ */ t.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-10 fill-white", fill: "currentColor", viewBox: "0 0 16 16", children: /* @__PURE__ */ t.jsx("path", { fillRule: "evenodd", d: "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM6.472 15.29a1.176 1.176 0 0 1-.111-.449h.765a.578.578 0 0 0 .254.384c.07.049.154.087.25.114.095.028.202.041.319.041.164 0 .302-.023.413-.07a.559.559 0 0 0 .255-.193.507.507 0 0 0 .085-.29.387.387 0 0 0-.153-.326c-.101-.08-.255-.144-.462-.193l-.619-.143a1.72 1.72 0 0 1-.539-.214 1.001 1.001 0 0 1-.351-.367 1.068 1.068 0 0 1-.123-.524c0-.244.063-.457.19-.639.127-.181.303-.322.527-.422.225-.1.484-.149.777-.149.305 0 .564.05.78.152.216.102.383.239.5.41.12.17.186.359.2.566h-.75a.56.56 0 0 0-.12-.258.625.625 0 0 0-.247-.181.923.923 0 0 0-.369-.068c-.217 0-.388.05-.513.152a.472.472 0 0 0-.184.384c0 .121.048.22.143.3a.97.97 0 0 0 .405.175l.62.143c.217.05.406.12.566.211a1 1 0 0 1 .375.358c.09.148.135.335.135.56 0 .247-.063.466-.188.656a1.216 1.216 0 0 1-.539.439c-.234.105-.52.158-.858.158-.254 0-.476-.03-.665-.09a1.404 1.404 0 0 1-.478-.252 1.13 1.13 0 0 1-.29-.375Zm-2.945-3.358h-.893L1.81 13.37h-.036l-.832-1.438h-.93l1.227 1.983L0 15.931h.861l.853-1.415h.035l.85 1.415h.908L2.253 13.94l1.274-2.007Zm2.727 3.325H4.557v-3.325h-.79v4h2.487v-.675Z" }) }),
    color: "bg-emerald-600"
  },
  {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    icon: /* @__PURE__ */ t.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-10 fill-white", fill: "currentColor", viewBox: "0 0 16 16", children: /* @__PURE__ */ t.jsx("path", { fillRule: "evenodd", d: "M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM7.86 14.841a1.13 1.13 0 0 0 .401.823c.13.108.29.192.479.252.19.061.411.091.665.091.338 0 .624-.053.858-.158.237-.105.416-.252.54-.44a1.17 1.17 0 0 0 .187-.656c0-.224-.045-.41-.135-.56a1.002 1.002 0 0 0-.375-.357 2.028 2.028 0 0 0-.565-.21l-.621-.144a.97.97 0 0 1-.405-.176.37.37 0 0 1-.143-.299c0-.156.061-.284.184-.384.125-.101.296-.152.513-.152.143 0 .266.023.37.068a.624.624 0 0 1 .245.181.56.56 0 0 1 .12.258h.75a1.093 1.093 0 0 0-.199-.566 1.21 1.21 0 0 0-.5-.41 1.813 1.813 0 0 0-.78-.152c-.293 0-.552.05-.777.15-.224.099-.4.24-.527.421-.127.182-.19.395-.19.639 0 .201.04.376.123.524.082.149.199.27.351.367.153.095.332.167.54.213l.618.144c.207.049.36.113.462.193a.387.387 0 0 1 .153.326.512.512 0 0 1-.085.29.558.558 0 0 1-.255.193c-.111.047-.25.07-.413.07-.117 0-.224-.013-.32-.04a.837.837 0 0 1-.249-.115.578.578 0 0 1-.255-.384h-.764Zm-3.726-2.909h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415H1.5l1.24-2.016-1.228-1.983h.931l.832 1.438h.036l.823-1.438Zm1.923 3.325h1.697v.674H5.266v-3.999h.791v3.325Zm7.636-3.325h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415h-.861l1.24-2.016-1.228-1.983h.931l.832 1.438h.036l.823-1.438Z" }) }),
    color: "bg-emerald-600"
  }
], Re = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/tiff"], S0 = ({ file: a, index: l }) => {
  const [p, x] = Ue(null);
  q(() => {
    if (a) {
      const f = URL.createObjectURL(a);
      return x(f), () => URL.revokeObjectURL(f);
    }
  }, [a]);
  const y = Ze.filter((f) => f.type == a.type), s = O(k).state.componentState, { dispatch: v } = O(k), g = () => {
    v({
      type: "STORE_FILE_STATE",
      payload: {
        zoom: !0,
        fileSrc: URL.createObjectURL(a),
        index: l,
        isImage: Re.includes(a.type),
        fileName: a.name,
        type: a.type,
        size: a.size
      }
    });
  };
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx(
      "div",
      {
        "data-testid": "file-preview",
        onClick: () => g(),
        className: `${s.rounded && "rounded-lg"} border-solid border-slate-200 hover:shadow-lg  shadow-md hover:cursor-pointer`,
        children: Re.includes(a.type) ? p && /* @__PURE__ */ t.jsx(
          "img",
          {
            "data-testid": "image-preview",
            src: p,
            className: `${s.fileHeight} ${s.fileWidth} object-fill scale-[0.9]`
          }
        ) : /* @__PURE__ */ t.jsx(
          "div",
          {
            "data-testid": "file-icon-preview",
            className: `${s.fileHeight} ${s.fileWidth} flex flex-col justify-center content-center items-center`,
            children: /* @__PURE__ */ t.jsx(
              "span",
              {
                className: `${y.length > 0 ? y[0].color : "bg-slate-400"} 
                        rounded flex w-16 justify-center h-20 items-center`,
                children: y.length > 0 ? y[0].icon : /* @__PURE__ */ t.jsxs(
                  "svg",
                  {
                    "data-testid": "default-icon",
                    xmlns: "http://www.w3.org/2000/svg",
                    className: "h-10 w-40 text-4xl",
                    viewBox: "0 0 16 16",
                    children: [
                      /* @__PURE__ */ t.jsx("path", { d: "M7 4.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm-.861 1.542 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V7.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V7s1.54-1.274 1.639-1.208zM5 9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z" }),
                      /* @__PURE__ */ t.jsx("path", { d: "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" })
                    ]
                  }
                )
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ t.jsx("div", { className: "h-5 w-44", children: p && /* @__PURE__ */ t.jsx(R0, { file: a, fileSrc: p, index: l, isImage: Re.includes(a.type) }) })
  ] });
}, T0 = () => {
  const a = O(k).state.fileData, l = O(k).state.fileState;
  return /* @__PURE__ */ t.jsx("div", { id: "slider-count", className: "absolute bottom-5 right-0 left-0 flex items-center justify-center z-50", children: (l == null ? void 0 : l.index) !== null && /* @__PURE__ */ t.jsx("div", { className: "text-white text-1xl", children: `${l.index + 1} of ${a == null ? void 0 : a.length}` }) });
}, k0 = () => {
  const a = O(k).state.fileState, l = O(k).state.componentState, p = Ze.filter((f) => f.type === a.type), { dispatch: x } = O(k), y = () => {
    a.fileSrc && URL.revokeObjectURL(a.fileSrc), x({
      type: "STORE_FILE_STATE",
      payload: {
        zoom: !1,
        fileSrc: null,
        index: 0,
        isImage: !1,
        fileName: null,
        type: null,
        size: 0
      }
    });
  }, s = () => {
    x({ type: "GET_NEXT_FILE" });
  }, v = () => {
    x({ type: "GET_PREV_FILE" });
  }, g = () => {
    const f = document.documentElement;
    document.fullscreenElement ? document.exitFullscreen && document.exitFullscreen() : f.requestFullscreen && f.requestFullscreen();
  };
  return a.zoom ? /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsxs(
    "div",
    {
      id: "slider",
      className: "fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-black bg-opacity-80 z-20",
      children: [
        /* @__PURE__ */ t.jsxs(
          "div",
          {
            id: "slider-header",
            className: "absolute top-0 left-0 right-0 flex justify-between items-center p-2 shadow-md shadow-gray-950 bg-black bg-opacity-80",
            children: [
              /* @__PURE__ */ t.jsx("span", { className: "text-white flex-1 ml-14 max-sm:ml-1", children: a.fileName }),
              /* @__PURE__ */ t.jsx(
                "button",
                {
                  className: "text-white text-sm flex items-center mr-4  max-sm:mr-1 hover:bg-white hover:text-black rounded-lg pl-2 pr-2 pt-1 pb-1",
                  onClick: g,
                  "aria-label": "toggle-fullscreen",
                  children: /* @__PURE__ */ t.jsx(
                    "svg",
                    {
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "currentColor",
                      className: "h-4 stroke-2",
                      viewBox: "0 0 16 16",
                      children: /* @__PURE__ */ t.jsx("path", { d: "M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0 1h-4zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zM.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5z" })
                    }
                  )
                }
              ),
              a.fileSrc && l.downloadFile && /* @__PURE__ */ t.jsxs(
                "a",
                {
                  href: a.fileSrc,
                  target: "_blank",
                  rel: "noreferrer",
                  download: a == null ? void 0 : a.fileName,
                  className: "text-white text-sm flex items-center mr-4 max-sm:mr-1 hover:bg-white hover:text-black rounded-lg pl-2 pr-2 pt-1 pb-1",
                  children: [
                    /* @__PURE__ */ t.jsx(
                      "svg",
                      {
                        fill: "none",
                        stroke: "currentColor",
                        className: "mr-1 h-4 stroke-2",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg",
                        "aria-hidden": "true",
                        children: /* @__PURE__ */ t.jsx(
                          "path",
                          {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            d: "M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
                          }
                        )
                      }
                    ),
                    "Download"
                  ]
                }
              ),
              /* @__PURE__ */ t.jsxs(
                "button",
                {
                  className: "text-white text-sm flex items-center mr-2 max-sm:mr-0 hover:bg-white hover:text-black rounded-lg pl-2 pr-2 pt-1 pb-1",
                  onClick: y,
                  children: [
                    /* @__PURE__ */ t.jsx(
                      "svg",
                      {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        strokeWidth: "1.5",
                        stroke: "currentColor",
                        className: "mr-1 w-4 h-4",
                        children: /* @__PURE__ */ t.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M6 18L18 6M6 6l12 12" })
                      }
                    ),
                    "Close"
                  ]
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ t.jsx(
          "button",
          {
            id: "slider-prev-button",
            className: "absolute top-1/2 left-1 ml-2 p-1 max-sm:top-3/4 transform -translate-y-1/2 z-20 text-white rounded-full hover:bg-white hover:text-black",
            onClick: v,
            "data-testid": "prev-file",
            children: /* @__PURE__ */ t.jsx(
              "svg",
              {
                fill: "none",
                className: "h-10 w-10 stroke-white transform rotate-180 stroke-2 hover:stroke-black",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                children: /* @__PURE__ */ t.jsx(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M8.25 4.5l7.5 7.5-7.5 7.5"
                  }
                )
              }
            )
          }
        ),
        /* @__PURE__ */ t.jsx(
          "div",
          {
            id: "file-slider",
            "data-testid": "image-slider",
            className: `${l.rounded && "rounded-lg"} relative w-[130vh] max-sm:w-96 max-md:w-[75vh] h-[78vh] max-sm:h-52 max-md:h-80   bg-slate-400 overflow-hidden transition-all delay-750 ease-in`,
            children: a.isImage ? a.fileSrc && /* @__PURE__ */ t.jsx("img", { className: "object-fit w-full h-full ", src: a.fileSrc, alt: "Zoomed Image" }) : /* @__PURE__ */ t.jsx("span", { className: "flex w-full h-full items-center justify-center text-4xl", children: /* @__PURE__ */ t.jsx(
              "span",
              {
                className: `${p.length > 0 ? p[0].color : "bg-slate-400"} rounded flex justify-center  w-48 h-48 items-center`,
                children: p.length > 0 ? p[0].icon : /* @__PURE__ */ t.jsxs(
                  "svg",
                  {
                    "data-testid": "default-icon",
                    xmlns: "http://www.w3.org/2000/svg",
                    className: "h-10 w-40 text-4xl",
                    viewBox: "0 0 16 16",
                    children: [
                      /* @__PURE__ */ t.jsx("path", { d: "M7 4.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm-.861 1.542 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V7.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V7s1.54-1.274 1.639-1.208zM5 9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z" }),
                      /* @__PURE__ */ t.jsx("path", { d: "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" })
                    ]
                  }
                )
              }
            ) })
          }
        ),
        /* @__PURE__ */ t.jsx(
          "button",
          {
            id: "slider-next-button",
            className: "absolute top-1/2 mr-2 p-1 right-1 max-sm:top-3/4  transform -translate-y-1/2 text-white rounded-full hover:bg-white hover:text-black",
            onClick: s,
            "data-testid": "next-file",
            children: /* @__PURE__ */ t.jsx(
              "svg",
              {
                fill: "none",
                className: " stroke-white h-10 w-10 stroke-2 hover:stroke-black",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                children: /* @__PURE__ */ t.jsx(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M8.25 4.5l7.5 7.5-7.5 7.5"
                  }
                )
              }
            )
          }
        ),
        l.showSliderCount ? /* @__PURE__ */ t.jsx(T0, {}) : /* @__PURE__ */ t.jsx(t.Fragment, {})
      ]
    }
  ) }) : null;
}, C0 = (a) => /* @__PURE__ */ t.jsx(t.Fragment, { children: /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsxs("div", { className: "flex justify-between  bg-gray-200 dark:bg-gray-600 ", children: [
  /* @__PURE__ */ t.jsx("div", { className: "h-10 text-sm pt-2 ml-2 font-medium", children: /* @__PURE__ */ t.jsx("span", { className: "bg-gray-100 text-gray-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300", children: `Files: ${a.fileData.length}` }) }),
  /* @__PURE__ */ t.jsxs(
    "label",
    {
      htmlFor: a.id,
      className: `${a.disabled ? "cursor-not-allowed opacity-50  py-1 px-2 mt-1 mr-2 mb-1 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700" : "cursor-pointer py-1 px-2 mt-1 mr-2 mb-1 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"} `,
      children: [
        "+ Add more",
        /* @__PURE__ */ t.jsx(
          "input",
          {
            id: a.id,
            disabled: a.disabled,
            type: "file",
            onChange: (l) => {
              a.handleImage(l), a.onChange && a.onChange(l);
            },
            style: { display: "none" },
            multiple: a.multiple ?? !0,
            accept: a.accept ?? ""
          }
        )
      ]
    }
  )
] }) }) }), O0 = Te.lazy(async () => {
  const { ReactPhotoEditor: a } = await import("./react-photo-editor.es-DlgDBnzZ.js");
  return { default: a };
}), A0 = ({
  id: a,
  files: l,
  url: p,
  downloadFile: x,
  removeFile: y,
  showFileSize: s,
  showSliderCount: v,
  allowEditing: g,
  multiple: f,
  accept: N,
  maxFileSize: b,
  maxFiles: R,
  width: F,
  rounded: L,
  height: J,
  fileHeight: re,
  fileWidth: ae,
  disabled: S,
  onChange: E,
  onRemove: ne,
  onError: z,
  getFiles: ie,
  onClick: le,
  onDrop: oe
}) => {
  const D = O(k).state.fileData, se = O(k).state.fileState, xe = O(k).state.componentState, I = O(k).state.imageEditorState, W = a ?? `fileInput-${Date.now()}`, { dispatch: _ } = O(k), P = (c) => {
    let m = !1;
    if (R && (D.length + c.length > R || c.length > R))
      throw m = !0, z && z(new Error(`Max ${R} files are allowed to be selected`)), new Error(`Max ${R} files are allowed to be selected`);
    return b && c.forEach((U) => {
      if (U.size > b)
        throw m = !0, z && z(new Error(`File size limit exceeded: ${U.name}`)), new Error(`File size limit exceeded: ${U.name}`);
    }), m;
  };
  q(() => {
    async function c() {
      try {
        if (p) {
          const m = [
            { type: "image/jpeg", ext: ".jpg" },
            { type: "image/jpg", ext: ".jpg" },
            { type: "image/png", ext: ".png" },
            { type: "image/gif", ext: "gif" },
            { type: "image/tiff", ext: ".tiff" }
          ], V = await (await fetch(p)).blob();
          let Z = null;
          const $ = m.filter((B) => B.type === V.type);
          $.length > 0 && (Z = $[0].ext);
          const K = new File([V], "file" + (Z ?? ".img"), {
            type: V.type
          });
          _({ type: "STORE_FILE_DATA", payload: { files: [K] } });
        }
      } catch (m) {
        if (m instanceof Error)
          throw z && z(m), m;
      }
    }
    c();
  }, []), q(() => {
    l && l.length > 0 && (P(l) || _({ type: "STORE_FILE_DATA", payload: { files: l } }));
  }, [l]), q(() => {
    _({
      type: "SET_COMPONENT_STATE",
      payload: {
        downloadFile: x ?? !0,
        removeFile: y ?? !0,
        showFileSize: s ?? !0,
        showSliderCount: v ?? !0,
        rounded: L ?? !0,
        fileHeight: re ?? "h-32",
        fileWidth: ae ?? "w-44",
        disabled: S ?? !1,
        allowEditing: g ?? !1
      }
    });
  }, [
    x,
    y,
    s,
    v,
    re,
    ae,
    L,
    S,
    g
  ]);
  const M = (c) => {
    const m = Array.from(c.target.files || []);
    P(m) || _({ type: "APPEND_FILE_DATA", payload: { files: m } });
  }, ce = (c) => {
    _({ type: "REMOVE_FILE_DATA", payload: c }), ne && ne(c);
  }, ue = (c) => {
    le && le(c);
  };
  q(() => {
    ie && ie(D);
  }, [D]);
  const fe = (c) => {
    c.preventDefault(), c.dataTransfer.dropEffect = "copy";
  }, de = (c) => {
    c.preventDefault();
  }, he = (c) => {
    c.preventDefault();
    const m = Array.from(c.dataTransfer.files);
    m && m.length > 0 && (P(m) || (_({ type: "APPEND_FILE_DATA", payload: { files: m } }), oe && oe(c)));
  }, ve = (c) => {
    if (c && I.index != null) {
      const m = Array.from(D);
      m[I.index] = c, _({
        type: "STORE_FILE_DATA",
        payload: {
          files: m
        }
      });
    }
  }, me = () => {
    _({
      type: "SET_IMAGE_EDITOR_DATA",
      payload: {
        isEditing: !1,
        file: null,
        index: null
      }
    });
  };
  return se.zoom ? /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsx(k0, {}) }) : I.isEditing && I.file ? /* @__PURE__ */ t.jsx(w0, { fallback: /* @__PURE__ */ t.jsx(t.Fragment, {}), children: /* @__PURE__ */ t.jsx(
    O0,
    {
      open: I.isEditing,
      file: I.file,
      onSaveImage: ve,
      onClose: me,
      downloadOnSave: !1
    }
  ) }) : /* @__PURE__ */ t.jsx("div", { className: "w-full", children: /* @__PURE__ */ t.jsx("div", { className: "flex flex-row max-h-2", children: /* @__PURE__ */ t.jsxs("div", { className: `${F ?? "basis-11/12"} mx-auto`, children: [
    D.length > 0 && /* @__PURE__ */ t.jsx(
      C0,
      {
        id: W,
        fileData: D,
        multiple: f,
        disabled: S,
        accept: N,
        onChange: E,
        handleImage: M
      }
    ),
    /* @__PURE__ */ t.jsx(
      "div",
      {
        className: `${J && `overflow-auto ${J}`} ${D.length == 0 && `border-2 border-dashed border-gray-300 ${S ? "" : "hover:bg-stone-200"} `} flex flex-row flex-wrap gap-4 p-6 bg-stone-100  shadow dark:bg-gray-800 `,
        onDragOver: S ? void 0 : fe,
        onDragLeave: S ? void 0 : de,
        onDrop: S ? void 0 : he,
        "data-testid": "dropzone",
        children: D.length > 0 ? D.map((c, m) => /* @__PURE__ */ t.jsxs("div", { className: "relative pb-5 group", onClick: () => ue(c), children: [
          /* @__PURE__ */ t.jsx("div", { className: "ml-9", children: xe.removeFile ? /* @__PURE__ */ t.jsx(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              "data-testid": "remove-file-button",
              onClick: () => ce(c),
              className: "absolute -top-2 right-0 z-10 text-black opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer h-5 w-5",
              fill: "currentColor",
              viewBox: "0 0 16 16",
              children: /* @__PURE__ */ t.jsx("path", { d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" })
            }
          ) : /* @__PURE__ */ t.jsx(t.Fragment, {}) }),
          /* @__PURE__ */ t.jsx("div", { className: "clear-right", children: /* @__PURE__ */ t.jsx(S0, { file: c, index: m }) })
        ] }, m)) : /* @__PURE__ */ t.jsxs(
          "label",
          {
            htmlFor: W,
            className: `text-black dark:text-slate-100 ${S ? "mx-auto cursor-not-allowed  flex items-center" : "mx-auto cursor-pointer  flex items-center"}`,
            children: [
              "Drop files here, or click to browse files",
              /* @__PURE__ */ t.jsx(
                "input",
                {
                  id: W,
                  disabled: S,
                  type: "file",
                  onChange: (c) => {
                    M(c), E && E(c);
                  },
                  multiple: f ?? !0,
                  accept: N ?? "",
                  style: { display: "none" }
                }
              )
            ]
          }
        )
      }
    )
  ] }) }) });
}, F0 = (a) => /* @__PURE__ */ t.jsx(_0, { children: /* @__PURE__ */ t.jsx(A0, { ...a }) });
export {
  F0 as ReactFilesPreview
};
